import React from "react";
import { Check } from "lucide-react";

export interface CustomCheckboxProps {
  id?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  id,
  checked,
  onChange,
  disabled = false,
  className = "",
}) => {
  return (
    <div className="relative inline-flex items-center">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className="sr-only peer"
      />
      <label
        htmlFor={id}
        className={`
          peer h-5 w-5 shrink-0 rounded-lg border-2 border-primary 
          ring-offset-background transition-all duration-200 
          cursor-pointer inline-flex items-center justify-center
          hover:border-primary/80 hover:shadow-sm hover:shadow-primary/10
          focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:ring-offset-2
          peer-checked:bg-primary peer-checked:text-white peer-checked:border-primary 
          peer-checked:shadow-sm peer-checked:shadow-primary/15
          peer-disabled:cursor-not-allowed peer-disabled:opacity-50
          active:scale-95
          ${className}
        `}
      >
        {checked && <Check className="h-4 w-4 text-white" />}
      </label>
    </div>
  );
};

export default CustomCheckbox;
